import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const FilterModal = ({ isOpen, onClose, filters, onApplyFilters }) => {
  const [selectedFilters, setSelectedFilters] = useState(filters);

  const handleFilterChange = (category, value, checked) => {
    setSelectedFilters(prev => ({
      ...prev,
      [category]: checked 
        ? [...(prev?.[category] || []), value]
        : (prev?.[category] || [])?.filter(item => item !== value)
    }));
  };

  const handleApply = () => {
    onApplyFilters(selectedFilters);
    onClose();
  };

  const handleReset = () => {
    setSelectedFilters({});
  };

  const getActiveFilterCount = () => {
    return Object.values(selectedFilters)?.reduce((count, arr) => count + (arr?.length || 0), 0);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card rounded-lg border border-border w-full max-w-md max-h-[80vh] overflow-hidden">
        <div className="flex items-center justify-between p-6 border-b border-border">
          <h3 className="font-semibold text-foreground flex items-center space-x-2">
            <Icon name="SlidersHorizontal" size={20} />
            <span>Advanced Filters</span>
          </h3>
          <button
            onClick={onClose}
            className="p-2 hover:bg-muted rounded-lg transition-colors duration-200"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="p-6 overflow-y-auto max-h-[60vh]">
          <div className="space-y-6">
            {/* File Type Filter */}
            <div>
              <h4 className="font-medium text-foreground mb-3">File Type</h4>
              <div className="space-y-2">
                {['PDF', 'DOC', 'XLS', 'PPT', 'ZIP']?.map((type) => (
                  <Checkbox
                    key={type}
                    label={type}
                    checked={selectedFilters?.fileType?.includes(type) || false}
                    onChange={(e) => handleFilterChange('fileType', type, e?.target?.checked)}
                  />
                ))}
              </div>
            </div>

            {/* Date Range Filter */}
            <div>
              <h4 className="font-medium text-foreground mb-3">Updated</h4>
              <div className="space-y-2">
                {['Last 7 days', 'Last 30 days', 'Last 3 months', 'Last year']?.map((range) => (
                  <Checkbox
                    key={range}
                    label={range}
                    checked={selectedFilters?.dateRange?.includes(range) || false}
                    onChange={(e) => handleFilterChange('dateRange', range, e?.target?.checked)}
                  />
                ))}
              </div>
            </div>

            {/* Department Filter */}
            <div>
              <h4 className="font-medium text-foreground mb-3">Department</h4>
              <div className="space-y-2">
                {['Mechanical Engineering', 'Electrical Engineering', 'Computer Science', 'Civil Engineering', 'Administration']?.map((dept) => (
                  <Checkbox
                    key={dept}
                    label={dept}
                    checked={selectedFilters?.department?.includes(dept) || false}
                    onChange={(e) => handleFilterChange('department', dept, e?.target?.checked)}
                  />
                ))}
              </div>
            </div>

            {/* Access Level Filter */}
            <div>
              <h4 className="font-medium text-foreground mb-3">Access Level</h4>
              <div className="space-y-2">
                {['Public', 'Students Only', 'Faculty Only', 'Restricted']?.map((level) => (
                  <Checkbox
                    key={level}
                    label={level}
                    checked={selectedFilters?.accessLevel?.includes(level) || false}
                    onChange={(e) => handleFilterChange('accessLevel', level, e?.target?.checked)}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-between p-6 border-t border-border">
          <Button
            variant="ghost"
            onClick={handleReset}
            iconName="RotateCcw"
            iconPosition="left"
          >
            Reset
          </Button>
          <div className="flex items-center space-x-3">
            <Button variant="outline" onClick={onClose}>
              Cancel
            </Button>
            
            <Button
              variant="default"
              onClick={handleApply}
              iconName="Check"
              iconPosition="left"
            >
              Apply Filters {getActiveFilterCount() > 0 && `(${getActiveFilterCount()})`}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterModal;